// extracted by mini-css-extract-plugin
var _1 = "ImportStep_icon__vAkJo";
export { _1 as "icon" }
